// countdown.styles.ts
import styled, { keyframes } from 'styled-components';
import { mediaq } from '~/themes/style-utils-v2';
import { newColors } from '~/themes/variables';
const pulseAnimation = keyframes `
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
`;
export const TickerContainer = styled.div `
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: 8px;
  ${mediaq.sm `
  gap: 4px;
  `}
`;
export const NumberContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 18px;
  color: ${newColors.gray800};
  background: ${newColors.purpleAlpha};
  gap: 8px;
  line-height: 1;
  height: 85px;
  width: 70px;
  ${mediaq.sm `
  width: 58px;
  height: 68px;
  gap: 2px;
  `}
`;
export const Value = styled.span `
  font-weight: 500;
  font-size: 24px;
`;
export const Label = styled.small `
  font-weight: 500;
  font-size: 12px;
  ${mediaq.sm `
  font-size: 10px;
  `}
`;
export const SkeletonNumberContainer = styled(NumberContainer) `
  background: ${newColors.gray300};
  animation: ${pulseAnimation} 1.5s ease-in-out infinite;
`;
